import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { SpecialFormControl } from '@utilities/SpecialForms';
import { isNullOrUndefined } from 'util';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'control-checkbox',
  templateUrl: './control-checkbox.component.html',
  styleUrls: ['./control-checkbox.component.scss'],
})
export class ControlCheckboxComponent implements OnInit, OnDestroy {
  @Input('sfcontrol') _sfcontrol: SpecialFormControl;
  @Input('description') _description: string = '';
  
  @Output('changeEvent') _changeEvent: EventEmitter<any> = new EventEmitter();
  @Output() hyperLink: EventEmitter<string> = new EventEmitter();


  private _currentValue: boolean;
  private _finisher = new Subject<void>();

  ngOnInit(): void {
    this._sfcontrol.valueChanges.pipe(
      takeUntil( this._finisher )
    ).subscribe( i => {

        if ( !isNullOrUndefined( this._currentValue ) ) {
          if (this._currentValue !== i) {
            this._sfcontrol.setValue( this._currentValue );
            this._currentValue = null;
          }
        }

      } 
    );
  }

  public hyperlinkEvent(): void {
    this._currentValue = this._sfcontrol.value;
    this.hyperLink.emit( this._sfcontrol.name );
  }

  ngOnDestroy(): void {
    this._finisher.next();
  }

}
